import elizabeth350w from "images/better-employee-elizabeth-350w.jpg"
import elizabeth700w from "images/better-employee-elizabeth-700w.jpg"
import charlie400w from "images/better-employee-charlie-400w.jpg"
import charlie800w from "images/better-employee-charlie-800w.jpg"

export const Person = {
  Elizabeth: {
    large: {
      src: elizabeth700w,
      width: "700w",
    },
    small: {
      src: elizabeth350w,
      width: "350w",
    },
    alt: "Elizabeth from Better",
  },
  Charlie: {
    large: {
      src: charlie800w,
      width: "800w",
    },
    small: {
      src: charlie400w,
      width: "400w",
    },
    alt: "Charlie from Better",
  },
}
